import React from "react";
import { useEffect } from "react";
import ContactHero from "../../components/contact/contacthero";
import MainContact from "../../components/contact/contact";
const Contact = () => {
   
    useEffect(()=>{
        document.title ="Udoka | Contact"
})
    return ( 
        <div className="py-4 px-2 md:px-4">
       <ContactHero/>
       <MainContact/>
                </div>
     );
}
 
export default Contact;